import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const couponRouter: Array<RouteRecordRaw> = [
    {
        path: '/coupon-iso',
        name: '电子券进销存',
        component: Layout,
        redirect: '/coupon-iso/store',
        meta: { title: '电子券进销存', icon: 'icon-card', alwaysShow: true },
        children: [
            {
                path: 'store',
                name: '总库列表',
                component: () => import('@/views/coupon-iso/store/Index.vue'),
                meta: { title: '总库', keepAlive: true, depth: 30 }
            },
            {
                path: 'out-preview',
                name: '出库预览',
                component: () => import('@/views/coupon-iso/OutPreview.vue'),
                meta: { title: '出库预览' }
            },
            {
                path: 'coupon-list',
                name: '卡劵列表',
                component: () => import('@/views/coupon-iso/CouponList.vue'),
                meta: { title: '卡劵列表' }
            },
            {
                path: 'coupon-log',
                name: '卡劵修改记录',
                component: () => import('@/views/coupon-iso/CouponListLog.vue'),
                meta: { title: '卡劵修改记录' }
            },
            {
                path: 'supplier-list',
                name: '供应商列表',
                component: () => import('@/views/coupon-iso/SupplierList.vue'),
                meta: { title: '供应商列表' }
            },
            {
                path: 'channel-list',
                name: '渠道出库记录',
                component: () => import('@/views/coupon-iso/ChannelLog.vue'),
                meta: { title: '渠道出库记录' }
            },
            {
                path: 'channel-down-list',
                name: '渠道出劵下载',
                component: () => import('@/views/coupon-iso/ChannelDown.vue'),
                meta: { title: '渠道出劵下载' }
            },
            {
                path: 'search-list',
                name: '客服查券',
                component: () => import('@/views/coupon-iso/SearchList.vue'),
                meta: { title: '客服查券' }
            },
            {
                path: 'coupon-check',
                name: '生券审核',
                component: () => import('@/views/coupon-iso/CouponCheck.vue'),
                meta: { title: '生券审核', badge: 'unCouponAutomatic' }
            },
            {
                path: 'out-apply',
                name: '出库申请',
                component: () => import('@/views/coupon-iso/OutApply.vue'),
                meta: { title: '出库申请' }
            },
            {
                path: 'out-approve',
                name: '渠道出库审批',
                component: () => import('@/views/coupon-iso/OutApply.vue'),
                meta: { title: '渠道出库审批' }
            },
            {
                path: 'out-log',
                name: '总出库记录',
                component: () => import('@/views/coupon-iso/OutLog.vue'),
                meta: { title: '总出库记录' }
            },
            {
                path: 'channel_dot_add',
                name: '渠道加点',
                component: () => import('@/views/coupon-iso/ChannelAddDot.vue'),
                meta: { title: '渠道加点' }
            },
            {
                path: 'channel_dot_edit',
                name: '渠道加点编辑',
                component: () => import('@/views/coupon-iso/ChannelDotEdit.vue'),
                meta: { title: '渠道加点编辑' }
            },
            {
                path: 'product_dot_add',
                name: '商品加点',
                component: () => import('@/views/coupon-iso/ProductDotAdd.vue'),
                meta: { title: '商品加点' }
            },
            {
                path: 'product_dot_log',
                name: '商品加点修改记录',
                component: () => import('@/views/coupon-iso/ProductAddDotLog.vue'),
                meta: { title: '商品加点修改记录' }
            },
        ]
    }
]

export default couponRouter